import React from "react";

export function PreviewBox({ title, children }) {
  return (
    <div className="preview-box">
      {title && <strong>{title}</strong>}
      <div>{children}</div>
    </div>
  );
}

export default PreviewBox;
